module.exports={
    "baseClass" : ".js-carousel",
    "blockAutoInitClass": ".js-carousel-block-auto-init"
}
